import {React, useState, useEffect} from 'react';
import getBackend from 'backend/backend';
import { useTranslation } from "react-i18next";
import { Alert, Container, Table, Button } from 'react-bootstrap';
import SidebarPage from 'components/sidebar_page';
import { Paths } from 'paths';
import { useNavigate } from 'react-router-dom';
import { showConfirmation } from 'components/misc';
const DataIndexes = () => {
    const [t] = useTranslation('common');
    const [error, setError] = useState(null);

    const [dataIndexes, setDataIndexes] = useState([]);
    const [updateSeqNo, setUpdateSeqNo] = useState(0);
    const navigate = useNavigate();

    const getDataIndexes = async () => {
        const result = await getBackend().getDataIndexes();
        if (result.error !== null) {
            setError(result.error);
        } else {
            setDataIndexes(result.response.data_indexes);
        }
    }

    const deleteDataIndex = async (id) => {
        let result = await showConfirmation("Delete data index", "Are you really going to delete the data index? All data will be lost.");
        if (result.isConfirmed) {
            const result = await getBackend().deleteDataIndex(id);
            if (result.error !== null) {
                setError(result.error);
            } else {
                window.location.href = Paths.DataIndexes.path;
            }
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setUpdateSeqNo(prev => prev + 1);
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        getDataIndexes();
    }, [updateSeqNo]);

    return (
        <SidebarPage title={t('Data Indexes')} description={t('Data Indexes')}>
            {error && <Alert variant="danger">{error}</Alert>}
            <Container className="my-5">
                <h2 className="mb-4">{t('Data Indexes')}</h2>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>{t('ID')}</th>
                            <th>{t('File System Path')}</th>
                            <th>{t('State')}</th>
                            <th>{t('Actions')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataIndexes.map((dataIndex) => (
                            <tr key={dataIndex.id}>
                                <td>{dataIndex.id}</td>
                                <td>{dataIndex.file_system_path}</td>
                                <td>{dataIndex.state}</td>
                                <td>
                                    <Button className="custom-button" variant="light" size="sm" onClick={() =>
                                        navigate(Paths.DataIndex.path + '/' + dataIndex.id)
                                    }>
                                        {t('Details')}
                                    </Button>
                                    <br />
                                    <Button 
                                        className="my-2"
                                        variant="danger" 
                                        size="sm" 
                                        onClick={() =>
                                            deleteDataIndex(dataIndex.id)
                                        }
                                    >
                                        {t('Delete')}
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Container>
        </SidebarPage>
    );
};

export default DataIndexes;
